import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import { event, modalview } from '../../../../redux/actions/google';
import RouteTitle from '../../../../presentation/RouteTitle';
import Loading from '../../../../presentation/Loading';
import EtelAPI from '../../../../api/EtelAPI';
import Alerts from '../../../../prototypes/Alerts';
import PageAuthorize from '../../../../security/PageAuthorize';
import AniTraceRecordsDialog from './AniTraceRecordsDialog'

class AniTraceList extends React.Component {
  constructor( props ){
    super( props );

    // Referneces
    this._ismounted = false;

    // Section Property Indices
    this._sectionPropsIndices = {
      COUNTS_DETAIL: 0,
      DIP_LOGS: 1,
      ANI_BLOCKING: 2,
      PROGRAMS_ANI: 3,
      ANI_DATA: 4,
      COUNTS_TRACKING: 5
    };
    
    this.state = {
      loading: false,
      activeKey: 0,
      data: [],
      value: '',
      valid_trace: false,
      today_only: true,
      dropdown: 0,
      showRecords: false,
      aniBlocking: [],
      aniData: {},
      countsDetail: {},
      dipLogs:[],
      countsTracking: [],
      sections: [
        {
          caption: 'COUNTS DETAIL',
          expanded: false,
        },
        {
          caption: 'DIP LOGS',
          expanded: false
        },
        {
          caption: 'ANI BLOCKING',
          expanded: false
        },
        {
          caption: 'ANI DATA',
          expanded: false
        },
        {
          caption: 'COUNTS TRACKING',
          expanded: false
        }
      ]
    };

    // Bindings
    this.getTrace = this.getTrace.bind( this );
    this.getData = this.getData.bind( this );
    this.onInput = this.onInput.bind( this );
    this.onKeyPress = this.onKeyPress.bind( this );
    this.toggleSelection = this.toggleSelection.bind( this );
    this.dropDownChange = this.dropDownChange.bind( this );
    this.onChangeTab = this.onChangeTab.bind( this );
    this.onReviewANIData = this.onReviewANIData.bind( this );
    this.onReviewCountsDetail = this.onReviewCountsDetail.bind( this );
    this.onReviewCountsTracking = this.onReviewCountsTracking.bind( this );
    this.onCloseDialog = this.onCloseDialog.bind( this );
    this.onToggleSection = this.onToggleSection.bind( this );
  }

  componentDidMount(){
    // Set the mount object state
    this._ismounted = true;
    window.addEventListener('keypress', this.onKeyPress );
    this.getData({});
  }

  // Removing resizing window action
  componentWillUnmount() {
    this._ismounted = false;
    window.removeEventListener('keypress', this.onKeyPress );
  }

  doLogOff( ) {
    const { dispatch } = this.props;
    const auth = this.props.auth;
    const history = this.props.history;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  onHandleException( e ) {
    const title = 'ANI Trace';
    const bugsnag = this.props.bugsnag;
    const { dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const status = e.status === undefined ? 0 : e.status;
    if( status === 401 ) {
      alerts.INFO( title, 'Your session has expired.' , 5000 );
      this.doLogOff();
    } else if( status === 500 ) {
      alerts.INFO( title, e.statusText , 5000 );
      this.doLogOff();
    // This only needs to warn the user
    } else if( status === 400 ) {
      alerts.WARNING( title, 'Request timed out.', 5000 );
    } else {
      alerts.CRITICAL( title, e );
    }
  }

  /* Change that occurs on the dropdown */
  dropDownChange( e ){
    if( this._ismounted === true ){
      this.setState( {dropdown: parseInt( e.target.value, 10 )} );
    }
  }

  onChangeTab( key, content ) {

    if ( this.state.activeKey === key ) {
      return;
    }

    this.setState( {
      activeKey: parseInt( key, 10 )
    } );

  }

  onReviewANIData( CLIENT_ID, e ) {
    const calls = this.state.aniData;
    const call = calls[ CLIENT_ID ];
    if( Object.keys( call ).length > 0 ) {
      this.setState({ 
        call: call,
        showRecords: true
      } );
    }
  }

  onReviewCountsDetail( CLIENT_ID, e ) {
    const { dispatch } = this.props;
    const history = this.props.history;
    dispatch( modalview( history.location.hostname ) );
    dispatch( event('ANI Trace', 'ANI Trace Dialog', 'COUNTS DETAIL - '  + CLIENT_ID  ) );
    const calls = this.state.countsDetail;
    const call = calls[ CLIENT_ID ];
    if( Object.keys( call ).length > 0 ) {
      this.setState({ 
        call: call,
        showRecords: true
      } );
    }
  }

  onReviewCountsTracking( CLIENT_ID, e ) {
    const { dispatch } = this.props;
    const history = this.props.history;
    dispatch( modalview( history.location.hostname ) );
    dispatch( event('ANI Trace', 'ANI Trace Dialog', 'COUNTS TRACKING - ' + CLIENT_ID ) );
    const calls = this.state.countsTracking;
    const call = calls[ CLIENT_ID ];
    if( Object.keys( call ).length > 0 ) {
      this.setState({ 
        call: call,
        showRecords: true
      } );
    }
  }

  onCloseDialog( e ) {
    this.setState({ 
      call: {},
      showRecords: false
    } );
  }

  // Event that toggles a result section
  onToggleSection( sectionIndex, e ) {
    if( this._ismounted === true ) {
      let sections = this.state.sections;
      const expanded  = !sections[ sectionIndex ].expanded;
      for( var index = 0; index < sections.length; index++ ) {
        sections[ index ].expanded = false;
      }
      sections[ sectionIndex ].expanded = expanded;
      this.setState( { 
        sections: sections
      } );
    }
  }

  /* Flips the value of 'Show Trace for Today Only' */
  toggleSelection( e ) {
    if( this._ismounted === true ){
      this.setState( {
        today_only: e.target.checked
      } );
    }
  }

  /* Sends information to the backend */
  // This is validated to be a 10 digit input
  getTrace( ) {

    this.setState( { 
      loading: true,
      data: [],
    }, () => { 

      let today_only = this.state.today_only;

      // This will be broken down to only 10 digits
      let number = this.state.value;
      let filtered_number = '';

      // Filters all none numeric values out
      for( let index = 0; index < number.length; index++ ){
        const n = number.charAt( index );
        // Checks that the converted integer is a number
        if( Number.isNaN( parseInt( n, 10 ) ) !== true ){
          filtered_number = filtered_number + n;
        }
      }

      // Sets the filtered results back to number
      number = filtered_number;

      // -- ANI is no change       (0)
      // -- Inbound is 'T' prefix  (1)
      // -- Outbound is 'D' prefix (2)
      
      if( this.state.dropdown === 1 ){
        number = 'T' + number;
      }

      if( this.state.dropdown === 2 ) {
        number = 'D' + number;
      }

      // Checks that the number is 10 digits long
      this.getData( [{CALL_TYPE: 0}, {NUMBER: number}, {TODAY_ONLY: today_only === true ? 1 : 0}] );

    } );
  }

  /* Action that occurs when something is typed into the input */
  onInput( e ) {
    let value = e.target.value;
    if( this._ismounted === true )  { 

      if( value !== undefined ) {
        if( value.length === 0 ) {
          // Set the default state
          this.setState( { 
            value: value,
            valid_trace: false,
            data: [],
            loading: false
          } );
          return;
        }
      }

      // 10 digits expected, this checks for 10 digits
      if( value !== null && value.match( /\d/g ) !== null ) {
        if ( value.match( /\d/g ).length === 10 ) {
          // Indicate the number is valid
          this.setState( { 
            value: value,
            valid_trace: true,
            data: [],
            loading: false
          } );
          return;
        } 
      } 
      // Set the default state
      this.setState( { 
        value: value,
        valid_trace: false,
        data: [],
        loading: false
      } );

    }

  }

  /* Watch for Key Enter Pressed */
  onKeyPress( e ) {
    if( this._ismounted === true ) {
      if( this.state.valid_trace ) {
        if( e.keyCode === 13 ) {
          this.getTrace();
          return;
        }
      }
    }
  }
 
   /* Renders the top input value and selection options */
   onRenderFilter() {
    const filters = [];
    const validTrace = this.state.valid_trace;

    let getTraceButton = (
      <button className="get-trace-disabled-button"> GET TRACE </button>
    );
    
    if( validTrace ) {
      getTraceButton = (
        <button className="get-trace-enabled-button" onClick={this.getTrace} > GET TRACE </button>
      );
    }
    
    filters.push(
      <span key="anitrace-filter-number" className="anitrace-filter-field">
        <span>Number</span>
        <input type="text" value={this.state.value} onChange={this.onInput} />
      </span>
    );

    filters.push(
      <span key="anitrace-filter-number-type" className="anitrace-filter-field">
        <span>Number Type</span>
        <select value={this.state.dropdown} onChange={this.dropDownChange}>
          <option value={0}>ANI</option>
          <option value={1}>Number Dialed (Inbound)</option>
          <option value={2}>Dial To Number (Outbound)</option>
        </select>
      </span>
    );
     
    filters.push(
      <span key="anitrace-filter-today-only" className="anitrace-filter-field">
        <input type="checkbox" checked={this.state.today_only} onChange={this.toggleSelection} />
        <span id="checkbox">Show Trace for Today Only</span>
      </span>              
    )

    filters.push(
      <span key="anitrace-filter-get-trace-button" className="anitrace-filter-field">
        {getTraceButton}
      </span>                            
    )
     
    const data = this.state.data;
    if( data !== undefined ) {
      if( this.state.loading === false ) {
        filters.push(
          <span key="anitrace-filter-get-trace-results" className="anitrace-filter-field">
            <label>
              {'There were '}
              <span>{data.length}</span>
              {' record(s) found.'}
            </label>
          </span>
        );
      } else {
        filters.push(
          <span key="anitrace-filter-get-trace-results" className="anitrace-filter-field">
            <label>
              {'Please wait while loading...'}
            </label>
          </span>
        );
      }
    }

    return filters;
  }

  onRenderCountsDetailRecords() {
    let totalRows = 0;
    const rows = [];
    const calls = this.state.countsDetail;
    if( calls !== undefined ) {
      let callKeys = Object.keys( calls );
      if( callKeys.length > 0 ) {
        for( let keyIndex = 0; keyIndex < callKeys.length; keyIndex++ ) {
          const callKey = callKeys[ keyIndex ];
          const call = calls[ callKey ];  
          const rowKey = 'anitrace-content-body-row-' + keyIndex.toString();
          const googleSearch = "https://www.google.com/search?q=" + call.ANI;
          totalRows += call.rows.length 
          rows.push( 
            <span key={rowKey} className='anitrace-content-body-row' onClick={this.onReviewCountsDetail.bind(this,callKey)}>
              <span className="anitrace-content-trace-label">
                <span>CALL ID:</span>
                <span>{callKey}</span>
              </span>
              <label className="anitrace-content-position-label">
                {(keyIndex + 1).toString()}
              </label>
              <div className="anitrace-content-general-info">
                <div className="general-info-field">
                  <strong>ANI:</strong>
                  <span>
                    <a href={googleSearch} target="_blank" alt="Google search this ANI">
                      <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={{"width":"20px","height":"20px"}}>
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z">
                        </path>
                      </svg>                    
                    </a>
                    <span>
                      {call.ANI}
                    </span>
                  </span>
                </div>
                <div className="general-info-field">
                  <strong>Call Started:</strong>
                  <span>{call.CALL_START}</span>
                </div>
                <div className="general-info-field">
                  <strong>Call Ended:</strong>
                  <span>{call.CALL_END}</span>
                </div>
                <div className="general-info-field">
                  <strong>Number Dialed:</strong>
                  <span>{call.NUMBER_DIALED}</span>
                </div>
                <div className="general-info-field">
                  <strong>Outbound Number:</strong>
                  <span>{call.OUTBOUND_NUMBER}</span>
                </div>
                <div className="general-info-field">
                  <strong>Call Type:</strong>
                  <span>{call.CALL_TYPE}</span>
                </div>
                <div className="general-info-field">
                  <strong>Country Code:</strong>
                  <span>{call.CC}</span>
                </div>
                <div className="general-info-field">
                  <strong>Normalized Code:</strong>
                  <span>{call.NC}</span>
                </div>
                <div className="general-info-field">
                  <strong id="link">Total Records:</strong>
                  <span id="link" onClick={this.onReviewCountsDetail.bind(this,callKey)}>
                    {call.rows.length.toString()}
                  </span>
                </div>
              </div>
            </span>
          );
        }
      }
    }
    return this.onRenderSection( this._sectionPropsIndices.COUNTS_DETAIL, rows, totalRows );
  }

  onRenderCountsTracking() {
    let totalRows = 0;
    const rows = [];
    const calls = this.state.countsTracking;
    if( calls !== undefined ) {
      let callKeys = Object.keys( calls );
      if( callKeys.length > 0 ) {
        for( let keyIndex = 0; keyIndex < callKeys.length; keyIndex++ ) {
          const callKey = callKeys[ keyIndex ];
          const call = calls[ callKey ];  
          const rowKey = 'anitrace-content-body-row-' + keyIndex.toString();
          const googleSearch = "https://www.google.com/search?q=" + call.ANI;
          totalRows += call.rows.length;
          rows.push( 
            <span key={rowKey} className='anitrace-content-body-row' onClick={this.onReviewCountsTracking.bind(this,callKey)}>
              <span className="anitrace-content-trace-label">
                <span>CALL ID:</span>
                <span>{callKey}</span>
              </span>
              <label className="anitrace-content-position-label">
                {(keyIndex + 1).toString()}
              </label>
              <div className="anitrace-content-general-info">
                <div className="general-info-field">
                  <strong>ANI:</strong>
                  <span>
                    <a href={googleSearch} target="_blank" alt="Google search this ANI">
                      <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={{"width":"20px","height":"20px"}}>
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z">
                        </path>
                      </svg>                    
                    </a>
                    <span>
                      {call.ANI}
                    </span>
                  </span>
                </div>
                <div className="general-info-field">
                  <strong>Call Started:</strong>
                  <span>{call.CALL_START}</span>
                </div>
                <div className="general-info-field">
                  <strong>Call Ended:</strong>
                  <span>{call.CALL_END}</span>
                </div>
                <div className="general-info-field">
                  <strong>Number Dialed:</strong>
                  <span>{call.NUMBER_DIALED}</span>
                </div>
                <div className="general-info-field">
                  <strong>Outbound Number:</strong>
                  <span>{call.OUTBOUND_NUMBER}</span>
                </div>
                <div className="general-info-field">
                  <strong>Call Type:</strong>
                  <span>{call.CALL_TYPE}</span>
                </div>
                <div className="general-info-field">
                  <strong>Country Code:</strong>
                  <span>{call.CC}</span>
                </div>
                <div className="general-info-field">
                  <strong>Normalized Code:</strong>
                  <span>{call.NC}</span>
                </div>
                <div className="general-info-field">
                  <strong id="link">Total Records:</strong>
                  <span id="link" onClick={this.onReviewCountsTracking.bind(this,callKey)}>
                    {call.rows.length.toString()}
                  </span>
                </div>
              </div>
            </span>
          );
        }
      }
    }
    return this.onRenderSection( this._sectionPropsIndices.COUNTS_TRACKING, rows, totalRows );
  }

  onRenderDipLogRecords() {
    const rows = [];
    const dipLogs = this.state.dipLogs;
    if( dipLogs !== undefined ) {
      if( dipLogs.length > 0 ) {
        for( var rowIndex = 0; rowIndex < dipLogs.length; rowIndex++ ) {
          const row = dipLogs[ rowIndex ];
          const rowKey = 'anitrace-content-body-row-' + rowIndex.toString();
          const googleSearch = "https://www.google.com/search?q=" + row.ANI;
          rows.push( 
            <span key={rowKey} className='anitrace-content-body-row'>
              <span className="anitrace-content-trace-label">
                <span>DIP</span>
              </span>
              <label className="anitrace-content-position-label">
                {(rowIndex + 1).toString()}
              </label>
              <div className="anitrace-content-general-info">
                <div className="general-info-field">
                  <strong>ANI:</strong>
                  <span>
                    <a href={googleSearch} target="_blank" alt="Google search this ANI">
                      <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={{"width":"20px","height":"20px"}}>
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z">
                        </path>
                      </svg>                    
                    </a>
                    <span>
                      {row.ANI}
                    </span>
                  </span>
                </div>
                <div className="general-info-field">
                  <strong>Requested:</strong>
                  <span>{row.REQUEST_DATE}</span>
                </div>
                <div className="general-info-field">
                  <strong>Created:</strong>
                  <span>{row.CreateOn_Date}</span>
                </div>
                <div className="general-info-field">
                  <strong>URL:</strong>
                  <span>{row.MESSAGE}</span>
                </div>
              </div>
            </span>
          );
        }
      }
    }
    return this.onRenderSection( this._sectionPropsIndices.DIP_LOGS, rows );
  }

  onRenderANIBlockingRecords() {
    const rows = [];
    const aniBlocking = this.state.aniBlocking;
    if( aniBlocking !== undefined ) {
      if( aniBlocking.length > 0 ) {
        for( var rowIndex = 0; rowIndex < aniBlocking.length; rowIndex++ ) {
          const row = aniBlocking[ rowIndex ];
          const rowKey = 'anitrace-content-body-row-' + rowIndex.toString();
          const googleSearch = "https://www.google.com/search?q=" + row.ANI;
          const blockTypeId = row.MESSAGE === 'ANI ROUTE' ? 'routed' : 'blocked'
          rows.push( 
            <span key={rowKey} className='anitrace-content-body-row'>
              <span className="anitrace-content-trace-label">
                <span>ADDED TO ANI BLOCKING</span>
              </span>
              <label className="anitrace-content-position-label">
                {(rowIndex + 1).toString()}
              </label>
              <div className="anitrace-content-general-info">
                <div className="general-info-field">
                  <strong>ANI:</strong>
                  <span>
                    <a href={googleSearch} target="_blank" alt="Google search this ANI">
                      <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={{"width":"20px","height":"20px"}}>
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z">
                        </path>
                      </svg>                    
                    </a>
                    <span>
                      {row.ANI}
                    </span>
                  </span>
                </div>
                <div className="general-info-field">
                  <strong>PDNIS:</strong>
                  <span>{row.PDNIS}</span>
                </div>
                <div className="general-info-field">
                  <strong>Block Type:</strong>
                  <span id={blockTypeId}>{row.MESSAGE}</span>
                </div>
              </div>
            </span>
          );
        }
      }
    }
    return this.onRenderSection( this._sectionPropsIndices.ANI_BLOCKING, rows );
  }

  onRenderANIDataRecords() {
    // TODO: This will get put back after its verified
    //       the back-end script is correct. 
    return '';
    // let totalRows = 0;
    // const rows = [];
    // const calls = this.state.aniData;
    // if( calls !== undefined ) {
    //   let callKeys = Object.keys( calls );
    //   if( callKeys.length > 0 ) {
    //     for( let keyIndex = 0; keyIndex < callKeys.length; keyIndex++ ) {
    //       const callKey = callKeys[ keyIndex ];
    //       const call = calls[ callKey ];  
    //       const rowKey = 'anitrace-content-body-row-' + keyIndex.toString();
    //       const googleSearch = "https://www.google.com/search?q=" + call.ANI;
    //       totalRows += call.rows.length;
    //       rows.push( 
    //         <span key={rowKey} className='anitrace-content-body-row' onClick={this.onReviewANIData.bind(this,callKey)}>
    //           <span className="anitrace-content-trace-label">
    //             <span>CALL ID:</span>
    //             <span>{callKey}</span>
    //           </span>
    //           <label className="anitrace-content-position-label">
    //             {(keyIndex + 1).toString()}
    //           </label>
    //           <div className="anitrace-content-general-info">
    //             <div className="general-info-field">
    //               <strong>ANI:</strong>
    //               <span>
    //                 <a href={googleSearch} target="_blank" alt="Google search this ANI">
    //                   <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={{"width":"20px","height":"20px"}}>
    //                     <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z">
    //                     </path>
    //                   </svg>                    
    //                 </a>
    //                 <span>
    //                   {call.ANI}
    //                 </span>
    //               </span>
    //             </div>
    //             <div className="general-info-field">
    //               <strong>Call Started:</strong>
    //               <span>{call.CALL_START}</span>
    //             </div>
    //             <div className="general-info-field">
    //               <strong>Call Ended:</strong>
    //               <span>{call.CALL_END}</span>
    //             </div>
    //             <div className="general-info-field">
    //               <strong>Number Dialed:</strong>
    //               <span>{call.NUMBER_DIALED}</span>
    //             </div>
    //             <div className="general-info-field">
    //               <strong>Outbound Number:</strong>
    //               <span>{call.OUTBOUND_NUMBER}</span>
    //             </div>
    //             <div className="general-info-field">
    //               <strong>Call Type:</strong>
    //               <span>{call.CALL_TYPE}</span>
    //             </div>
    //             <div className="general-info-field">
    //               <strong>Country Code:</strong>
    //               <span>{call.CC}</span>
    //             </div>
    //             <div className="general-info-field">
    //               <strong>Normalized Code:</strong>
    //               <span>{call.NC}</span>
    //             </div>
    //             <div className="general-info-field">
    //               <strong id="link">Total Records:</strong>
    //               <span id="link" onClick={this.onReviewANIData.bind(this,callKey)}>
    //                 {call.rows.length.toString()}
    //               </span>
    //             </div>
    //           </div>
    //         </span>
    //       );
    //     }
    //   }
    // }
    // return this.onRenderSection( this._sectionPropsIndices.ANI_DATA, rows, totalRows );
  }

  onRenderSection( sectionIndex, children, totalRows ) {
    let totalChildRows = totalRows === undefined ? children.length : totalRows;
    if( this._ismounted === true ) {
      const sectionProps = this.state.sections[ sectionIndex ];
      if( sectionProps !== undefined ) {
        const iconClassName = sectionProps.expanded === true  ? 'icon-fontello-minus-1' : 'icon-fontello-plus-1';
        const bodyClassName = sectionProps.expanded === true ? 'anitrace-section-body' : 'anitrace-section-body-hidden';
        if( sectionProps !== undefined && sectionProps !== null && children !== undefined ) {
          if( children.length > 0 ) {
            return (
              <div key={'anitrace-section-' + sectionIndex.toString()} className="anitrace-section">
                <span className="anitrace-section-header">
                  <i className={iconClassName} onClick={this.onToggleSection.bind(this, sectionIndex)} />
                  <span className="anitrace-section-header-caption">
                    <span>{totalChildRows}</span> 
                    {sectionProps.caption}
                  </span>
                </span>
                <span className={bodyClassName}>
                  {children}
                </span>
              </div>
            );
          }
        }
      }
    }
    return '';
  }

  onRenderContentBody( ) {
    const data = this.state.data;
    const rows = [];
    const numberType = parseInt( this.state.dropdown, 10 );
    let noRowsLabel = '';

    if( numberType ===  0 ) {
      noRowsLabel = 'Please enter a valid ANI.';
    } else if( numberType === 1 ) {
      noRowsLabel = 'Please enter a valid Number Dialed (Inbound).';
    } else if( numberType === 2 ) {
      noRowsLabel = 'Please enter a valid Dialed to Number (Outbound).';
    } else {
      noRowsLabel = 'Please enter a valid ANI.';
    }

    if( data !== undefined ) {
      if( data.length > 0 ) {

        rows.push(
          this.onRenderANIBlockingRecords()
        );
        
        rows.push(
          this.onRenderANIDataRecords()
        );
        
        rows.push(
          this.onRenderCountsDetailRecords()
        );
        rows.push(
          this.onRenderCountsTracking()
        );
        
        rows.push(
          this.onRenderDipLogRecords()
        );
      } else {
        if( this.state.loading === true ) {
          rows.push(
            <Loading key="loading-rows" height="50px" width="200px" />
          );
        } else {
          rows.push(
            <span key="anitrace-content-body-norows" className="anitrace-content-body-norows">
              {noRowsLabel}
            </span>
          );
        }
      }
    } else {
      if( this.state.loading === true ) {
        rows.push(
          <Loading key="loading-rows" height="50px" width="200px" />
        );
      } else {
        rows.push(
          <span key="anitrace-content-body-norows" className="anitrace-content-body-norows">
            {noRowsLabel}
          </span>
        );
      }
    }
    return rows;  
  }

  /* Renders the content response body */
  getData( query ) {
    let { dispatch } = this.props;
    let countsDetail = {};
    const dipLogs = [];
    const aniBlocking = [];
    //const aniData = {};
    const countsTracking = {};
    let sections = this.state.sections;
    let api = new EtelAPI( 'technical/anitrace' );

    // Set section expanded property default value to false 
    let sectionKeys = Object.keys( sections );
    if( sectionKeys !== undefined ) {
      if( sectionKeys.length > 0  ) {
        for( let index = 0; index < sectionKeys.length; index++ ) {
          const key = sectionKeys[ index ];
          sections[ key ].expanded = false;
        }
      }
    }
    
    this.setState( { 
      loading: true,
      data: [],
      sections: sections
    }, ( ) => {

      // Retrieving the information from the back-end
      api.get( query ).then( ( result ) => {
        dispatch( event( 'ANI Trace', 'ANI Trace Search', 'SEARCH: ' + JSON.stringify( query ) ) );
        if( result !== undefined ) {
          if( result.length > 0 ) {
            let lastCountsDetailClientID = '';
            let lastCountsTrackingClientID = '';
            //let lastANIDataClientID = '';
            for( let index = 0; index < result.length; index++ ) {
              const row = result[ index ];
              if( row.TRACE === 'COUNTS DETAIL' )  {
                if( lastCountsDetailClientID !== row.CLIENT_ID ) {
                  countsDetail[ row.CLIENT_ID ] = {} ;
                  countsDetail[ row.CLIENT_ID ].CLIENT_ID = row.CLIENT_ID;
                  countsDetail[ row.CLIENT_ID ].CALL_START = row.REQUEST_DATE;
                  countsDetail[ row.CLIENT_ID ].CALL_END = row.REQUEST_DATE;
                  countsDetail[ row.CLIENT_ID ].ANI = row.ANI;
                  countsDetail[ row.CLIENT_ID ].NUMBER_DIALED = row.NUMBER_DIALED;
                  countsDetail[ row.CLIENT_ID ].OUTBOUND_NUMBER = row.OUTBOUND_NUMBER === '' ? '(N/A)' : row.OUTBOUND_NUMBER;
                  countsDetail[ row.CLIENT_ID ].CALL_TYPE = row.CALL_TYPE;
                  countsDetail[ row.CLIENT_ID ].CC = row.CC;
                  countsDetail[ row.CLIENT_ID ].NC = row.NC;
                  countsDetail[ row.CLIENT_ID ].rows = [];
                  countsDetail[ row.CLIENT_ID ].rows.push( row );
                } else {
                  countsDetail[ row.CLIENT_ID ].CALL_END = row.REQUEST_DATE;
                  countsDetail[ row.CLIENT_ID ].rows.push( row );
                } 
                lastCountsDetailClientID = result[ index ].CLIENT_ID;
              } 
              else if( row.TRACE === 'DIP LOG' ) {
                dipLogs.push( row );
              } else if( row.TRACE === 'ADDED TO ANI BLOCKING' ) {
                aniBlocking.push( row );
              } else if( row.TRACE === 'ANI DATA' ) {
                //TODO: will get put back when this verified the back-end script is correct.
                // if( lastANIDataClientID !== row.CLIENT_ID ) {
                //   aniData[ row.CLIENT_ID ] = {} ;
                //   aniData[ row.CLIENT_ID ].CLIENT_ID = row.CLIENT_ID;
                //   aniData[ row.CLIENT_ID ].CALL_START = row.REQUEST_DATE;
                //   aniData[ row.CLIENT_ID ].CALL_END = row.REQUEST_DATE;
                //   aniData[ row.CLIENT_ID ].ANI = row.ANI;
                //   aniData[ row.CLIENT_ID ].NUMBER_DIALED = row.NUMBER_DIALED;
                //   aniData[ row.CLIENT_ID ].OUTBOUND_NUMBER = row.OUTBOUND_NUMBER === '' ? '(N/A)' : row.OUTBOUND_NUMBER;
                //   aniData[ row.CLIENT_ID ].CALL_TYPE = row.CALL_TYPE;
                //   aniData[ row.CLIENT_ID ].CC = row.CC;
                //   aniData[ row.CLIENT_ID ].NC = row.NC;
                //   aniData[ row.CLIENT_ID ].rows = [];
                //   aniData[ row.CLIENT_ID ].rows.push( row );
                // } else {
                //   aniData[ row.CLIENT_ID ].CALL_END = row.REQUEST_DATE;
                //   aniData[ row.CLIENT_ID ].rows.push( row );
                // } 
                // lastANIDataClientID = result[ index ].CLIENT_ID;
              } else if( row.TRACE === 'COUNTS TRACKING' ) {
                if( lastCountsTrackingClientID !== row.CLIENT_ID ) {
                  countsTracking[ row.CLIENT_ID ] = {} ;
                  countsTracking[ row.CLIENT_ID ].CLIENT_ID = row.CLIENT_ID;
                  countsTracking[ row.CLIENT_ID ].CALL_START = row.REQUEST_DATE;
                  countsTracking[ row.CLIENT_ID ].CALL_END = row.REQUEST_DATE;
                  countsTracking[ row.CLIENT_ID ].ANI = row.ANI;
                  countsTracking[ row.CLIENT_ID ].NUMBER_DIALED = row.NUMBER_DIALED;
                  countsTracking[ row.CLIENT_ID ].OUTBOUND_NUMBER = row.OUTBOUND_NUMBER === '' ? '(N/A)' : row.OUTBOUND_NUMBER;
                  countsTracking[ row.CLIENT_ID ].CALL_TYPE = row.CALL_TYPE;
                  countsTracking[ row.CLIENT_ID ].CC = row.CC;
                  countsTracking[ row.CLIENT_ID ].NC = row.NC;
                  countsTracking[ row.CLIENT_ID ].rows = [];
                  countsTracking[ row.CLIENT_ID ].rows.push( row );
                } else {
                  countsTracking[ row.CLIENT_ID ].CALL_END = row.REQUEST_DATE;
                  countsTracking[ row.CLIENT_ID ].rows.push( row );
                } 
                lastCountsTrackingClientID = result[ index ].CLIENT_ID;
              }
            }
          }
        }

        this.setState( { 
          loading: false,
          data: result,
          countsDetail: countsDetail,
          dipLogs: dipLogs,
          aniBlocking: aniBlocking,
          countsTracking: countsTracking,
        } );

      } ).catch( ( error ) => {

        // DB error can occur if the number is not an 800 TFN on an Inbound look up (Production only),
        // this should set the Loading... to Total Row message instead
        this.onHandleException( error );

        this.setState( { 
          loading: false,
          countsDetail: {},
          dipLogs: [],
          aniBlocking: [],
          countsTracking: {},
          data: []
        } );

      } );

    } );
  }

   render( ) {
    return (
      <PageAuthorize groups={['Administrators','Operations','Management']}>
        <RouteTitle title='ANI Trace' />
        <AniTraceRecordsDialog show={this.state.showRecords} width={90} height={90} onClose={this.onCloseDialog} call={this.state.call} />
        <div className="anitrace">
          <div className='anitrace-header'>
            <span className="anitrace-header-cell-1">
            </span>
            <span className="anitrace-header-cell-2">
              <span>ANI Trace</span>
            </span>
            <span className="anitrace-header-cell-3">
            </span>              
          </div>
          <div className='anitrace-filter'>
            {this.onRenderFilter()}
          </div>
          <div className='anitrace-content'>
            <span className='anitrace-content-body'>
              {this.onRenderContentBody()}
            </span>
          </div>
        </div>
      </PageAuthorize>
    );
  }
}

export default withRouter(
  connect (
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( AniTraceList ) );


// WEBPACK FOOTER //
// ./src/content/enterprise/anitrace/components/AniTraceList.js